import React from 'react';
import { useTranslation } from 'react-i18next';
import { LogoIcon } from 'src/components';
import { SText } from 'src/components/SText';
import { ShippingRecap } from 'src/containers/CustomerDeliveryRequestContainer/ShippingRecap';
import { DeliveryPublicColiInfoDataModel } from '../DeliveryPublicColiInfo/delivery-public-colis-info.types';

type Props = {
  shipping: DeliveryPublicColiInfoDataModel;
  tracker: string;
  code: string;
  text: string;
  type: 'error' | 'success' | 'normal';
  testID?: string;
};

export const NoticeBlock: React.FC<Props> = ({ type, text, code, tracker, shipping }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center min-h-screen bg-primary md:px-4 md:py-6 mad:max-w-md w-full">
      <div className="flex md:justify-center min-h-screen bg-primary md:px-4 md:py-6">
        <div className=" bg-white px-2 py-2 md:p-10 relative w-auto">
          <LogoIcon className="w-40 md:w-40 my-2 m-auto" />

          <div className="py-4 m-auto flex justify-center">
            <SText
              label={text}
              classNames={`text-gray-700 text-base mb-6 md:text-xl  text-md text-center ${
                type === 'error' ? 'text-error' : type === 'normal' ? 'text-black' : 'text-teal-500'
              }`}
            />
          </div>
          <ShippingRecap shipping={shipping} />
          <div className=" flex m-auto justify-center items-center w-auto mt-3">
            <a
              href={`/info/${tracker}/${code}`}
              className="text-center w-full md:w-auto px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold text-lg rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-blue-300 inline-block m-auto"
            >
              {t('client-delivery-requests.track-your-colis')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
